/*
 *
 * ResetPassword reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE_RESETPASSWORD,
  LOAD_RESETPASSWORD,
  LOAD_RESETPASSWORD_SUCCESS,
  LOAD_RESETPASSWORD_ERROR,
  CHANGE_RESETPASSWORD,
  CHANGE_RESETPASSWORD_SUCCESS,
  CHANGE_RESETPASSWORD_ERROR,
  DELETE_RESETPASSWORD,
  DELETE_RESETPASSWORD_SUCCESS,
  DELETE_RESETPASSWORD_ERROR,
} from './constants';

export const initialState = {
  loading: false,
  error: false,
  deleteSuccessful: false,
  resetPasswordList: false,
  resetPasswordData: false,
};

/* eslint-disable default-case, no-param-reassign */
const resetPasswordReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE_RESETPASSWORD:
        return initialState;

      // LOAD
      case LOAD_RESETPASSWORD:
        draft.loading = true;
        draft.error = false;
        break;

      case LOAD_RESETPASSWORD_SUCCESS:
        draft.resetPasswordList = action.resetPasswordList;
        draft.loading = false;
        break;

      case LOAD_RESETPASSWORD_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // CHANGE/UPDATE
      case CHANGE_RESETPASSWORD:
        draft.resetPasswordData = {
          ...state.resetPasswordData,
          ...action.resetPasswordData,
        };
        draft.loading = true;
        draft.error = false;
        break;

      case CHANGE_RESETPASSWORD_SUCCESS:
        draft.loading = false;
        const { resetPasswordData } = action;
        draft.resetPasswordData = resetPasswordData;

        // update single item in the list inside state
        let listData = draft.resetPasswordList.data;
        let index = draft.resetPasswordList.data.findIndex(
          po => po._id === resetPasswordData._id,
        );
        index !== -1
          ? (listData[index] = resetPasswordData)
          : listData.unshift(resetPasswordData);
        draft.resetPasswordList = {
          ...draft.resetPasswordList,
          data: listData,
        };

        break;

      case CHANGE_RESETPASSWORD_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;

      // DELETE
      case DELETE_RESETPASSWORD:
        draft.loading = true;
        draft.id = action.id;
        break;

      case DELETE_RESETPASSWORD_SUCCESS:
        draft.loading = false;
        draft.deleteSuccessful = true;
        break;
    }
  });

export default resetPasswordReducer;
